module.exports = __webpack_public_path__ + "static/img/icon-pending-for.98bfe32f.svg";